import React from "react";
import {connect} from "react-redux";
import Create from "../../../components/CRM/Create";
import {
  DisabledInput,
  ReferenceInput,
  TextInput,
  LongTextInput,
  BooleanInput,
  required,
  email,
  TabbedForm,
  FormTab,
  TextField,
  BooleanField,
  SingleFieldList,
  SelectInput,
  ReferenceField,
  ChipField,
  DateField,
  translate,
  ReferenceArrayField
} from "admin-on-rest";
import DisabledInputLngLat from "../../../components/CRM/DisabledInput";
import AutoComplete from "material-ui/AutoComplete";
import AutocompleteInput from "../../../components/CRM/AutocompleteInput";
import TimeInput from "../../../components/CRM/TimeInput";
import {
  validateStoreData,
  validatePhone,
  validateStoreUrl,
  validateHeadline,
  validateAbout,
  validateFacebookPage,
  validateSender,
  validateMarketingPartnerID,
  validateCustomerNumber
} from "./validations";
import ReferenceSelectGrid from "../../../components/ReferenceSelectGrid";
import {formStyle} from "./style";
import AddressPicker from "./AddressPicker";
import ReferenceArrayInputNestedFilter from "../../../components/ReferenceArrayInputNestedFilter";
import PromoFilter from "../Promos/PromoFilter";
import ActionBar from "../../../components/CRM/ActionBar/";

const WorkingHoursLabelBase = ({translate, label}) => (
  <div style={formStyle.textFieldContainer}>
    <p style={formStyle.textStyle}>
      <span>{translate(label)}:</span>
    </p>
  </div>
);

const WorkingHoursLabel = translate(WorkingHoursLabelBase);

const InputHeaderBase = ({translate, header, headerStyle}) => (
  <div style={headerStyle}>
    <span>{translate(header)}:</span>
  </div>
);

const InputHeader = translate(InputHeaderBase);

class StoreCreateForm extends React.Component {
  state = {
    defaultAddress: {
      address: "",
      lat: "",
      lng: ""
    }
  };

  setDefaultAddress = address => {
    this.setState({
      defaultAddress: {
        address: address.address,
        lat: address.lat,
        lng: address.lng
      }
    });
  };

  render() {
    const props = {...this.props};
    const reduxErrors = {...props.errors};
    const errors = {...reduxErrors.syncErrors};
    const {translate} = props;
    const giftCardEnabledDefaultValue = false;

    const defaultWorkingHours = {
      working_hours: {
        regular: {
          start: new Date(2007, 11, 5, 8, 0, 0),
          end: new Date(2007, 11, 5, 20, 0, 0)
        },
        other: {
          start: new Date(2007, 11, 5, 8, 0, 0),
          end: new Date(2007, 11, 5, 20, 0, 0)
        }
      }
    };

    if (
      this.state.defaultAddress.address &&
      this.state.defaultAddress.address.trim() !== ""
    )
      delete errors.location;

    const defaultSender =
      this.props.configuration &&
      this.props.configuration.stores &&
      this.props.configuration.stores.default_sms_sender;

    return (
      <Create title="resources.stores.titleCreate" {...props}>
        <TabbedForm
          redirect="list"
          validate={validateStoreData}
          defaultValue={defaultWorkingHours}
        >
          <FormTab
            label="resources.stores.titleTab1"
            elStyle={formStyle.tabStyle}
          >
            <ReferenceInput
              style={formStyle.tabStyle}
              label="resources.stores.inputs.storeOwner"
              source="partner_id"
              reference="partners"
              validate={required}
              sort={{field: "last_name", order: "ASC"}}
              allowEmpty
              filterToQuery={fullName => ({full_name_like: fullName})}
            >
              <AutocompleteInput
                optionText={record =>
                  `${record.first_name} ${record.last_name}`
                }
                options={{filter: AutoComplete.caseInsensitiveFilter}}
              />
            </ReferenceInput>
            <TextInput
              label="resources.stores.inputs.storeName"
              source="name"
            />
            <ReferenceInput
              style={formStyle.tabStyle}
              label="resources.stores.inputs.region"
              source="region_id"
              reference="regions"
              sort={{field: "name", order: "ASC"}}
              perPage={50}
              allowEmpty={false}
            >
              <SelectInput optionText="name" />
            </ReferenceInput>
            <TextInput
              label="resources.stores.inputs.sender"
              source="sms_sender"
              defaultValue={defaultSender && defaultSender}
              validate={validateSender}
            />
            <TextInput
              label="resources.stores.inputs.phoneNumber"
              source="phone"
              validate={validatePhone}
            />
            <TextInput
              label="resources.stores.inputs.email"
              source="email"
              type="email"
              validate={email}
            />
            <BooleanInput
              label="resources.stores.inputs.active"
              source="active"
              defaultValue={true}
              style={{display: "none"}}
            />
            <BooleanInput
              label="resources.stores.inputs.hasQuestionnaire"
              source="has_questionnaire"
              style={formStyle.inputStyle.booleanInput}
              defaultValue
            />
            <TextInput
              label="resources.stores.inputs.storeUrlText"
              source="store_url"
              validate={validateStoreUrl}              
            />
            <TextInput
              label="resources.stores.inputs.customerNumber"
              source="customer_number"
              validate={validateCustomerNumber}
              style={formStyle.inputStyle.lastInput}
            />
          </FormTab>
          <FormTab
            label="resources.stores.titleTab2"
            elStyle={formStyle.tabStyle}
          >
            <LongTextInput
              label="resources.stores.inputs.headline"
              source="headline"
              validate={validateHeadline}
              style={formStyle.inputStyle}
            />
            <LongTextInput
              label="resources.stores.inputs.about"
              validate={validateAbout}
              source="about"
              style={formStyle.inputStyle}
            />
            <TextInput
              label="resources.stores.inputs.phoneNumber"
              source="contact_info.phone_number"
              validate={validatePhone}
            />
            <TextInput
              label="resources.stores.inputs.email"
              source="contact_info.email"
              type="email"
              validate={email}
            />
            <InputHeader
              header="resources.stores.inputs.workingHours.header"
              headerStyle={formStyle.headerContainer}
              style={formStyle.tabStyle}
            />
            <WorkingHoursLabel
              label="resources.stores.inputs.workingHours.regular.days"
              style={formStyle.labelStyle}
            />
            <TimeInput
              label="resources.stores.inputs.workingHours.regular.start"
              source="working_hours.regular.start"
              locale="sv"
              style={formStyle.containerInput}
            />
            <TimeInput
              label="resources.stores.inputs.workingHours.regular.end"
              source="working_hours.regular.end"
              locale="sv"
            />
            <div style={formStyle.clearFloatContainer} />
            <WorkingHoursLabel
              label="resources.stores.inputs.workingHours.other.saturday"
              style={formStyle.labelStyle}
            />
            <TimeInput
              label="resources.stores.inputs.workingHours.other.start"
              source="working_hours.saturday.start"
              locale="sv"
              style={formStyle.containerInput}
            />
            <TimeInput
              label="resources.stores.inputs.workingHours.other.end"
              source="working_hours.saturday.end"
              locale="sv"
            />
            <div style={formStyle.clearFloatContainer} />
            <WorkingHoursLabel
              label="resources.stores.inputs.workingHours.other.sunday"
              style={formStyle.labelStyle}
            />
            <TimeInput
              label="resources.stores.inputs.workingHours.other.start"
              source="working_hours.sunday.start"
              locale="sv"
              style={formStyle.containerInput}
            />
            <TimeInput
              label="resources.stores.inputs.workingHours.other.end"
              source="working_hours.sunday.end"
              locale="sv"
            />
            <div style={formStyle.clearFloatContainer} />
            <BooleanInput
              label="resources.stores.inputs.workingHours.holiday_differ"
              source="working_hours.holiday_differ"
              defaultValue
              style={formStyle.inputStyle.longBooleanInput}
            />
            <div style={formStyle.clearFloatContainer} />
            <InputHeader
              header="resources.stores.inputs.address"
              headerStyle={formStyle.headerContainer}
              style={formStyle.labelStyle}
            />
            <DisabledInput
              label=""
              source="location.address"
              defaultValue={this.state.defaultAddress.address}
              options={{fullWidth: true}}
              style={formStyle.addressInputStyle}
            />

            {errors.location && reduxErrors.submitFailed && (
              <span style={formStyle.validationStyle}>
                {translate("resources.stores.validation.address")}
              </span>
            )}

            <div style={formStyle.clearFloatContainer} />

            <AddressPicker
              setDefaultAddress={this.setDefaultAddress}
              address={this.state.defaultAddress}
              style={formStyle.pickerStyle}
            />

            <InputHeader
              header="resources.stores.inputs.lat"
              headerStyle={formStyle.latLngContainer}
              style={formStyle.labelStyle}
            />

            <DisabledInputLngLat
              label=""
              source="location.lat"
              defaultValue={this.state.defaultAddress.lat}
              customUnderlineDisabledStyle={formStyle.latLngInputStyle}
              elStyle={formStyle.lanLngStyle}
            />

            <InputHeader
              header="resources.stores.inputs.lng"
              headerStyle={formStyle.latLngContainer}
              style={formStyle.labelStyle}
            />

            <DisabledInputLngLat
              label=""
              source="location.lng"
              defaultValue={this.state.defaultAddress.lng}
              customUnderlineDisabledStyle={formStyle.latLngInputStyle}
              elStyle={formStyle.lanLngStyle}
            />
            
            <div style={formStyle.clearFloatContainer} />
            <TextInput
              label="resources.stores.inputs.facebookPage"
              source="facebook_page"
              validate={validateFacebookPage}
              options={{fullWidth: true}}
              style={formStyle.faceBookInputStyle}
            />
          </FormTab>

          {this.props.configuration.promos &&
            this.props.configuration.promos.enabled === true && (
              <FormTab label="resources.stores.titleTab3">
                <ReferenceArrayInputNestedFilter
                  reference="promos"
                  source="promo_ids"
                  location={props.location}
                  actions={
                    <ActionBar
                      createButton={false}
                      deleteButton={false}
                      withActionMenu={false}
                    />
                  }
                  filters={<PromoFilter isNested={true}/>}
                >
                  <ReferenceSelectGrid
                    options={{
                      multiSelectable: true,
                      selectable: true
                    }}
                    headerOptions={{
                      adjustForCheckbox: true,
                      displaySelectAll: true,
                      enableSelectAll: true
                    }}
                    bodyOptions={{
                      displayRowCheckbox: true,
                      deselectOnClickaway: false,
                      showRowHover: true
                    }}
                    rowOptions={{selectable: true}}
                  >
                    <TextField
                      label="resources.promos.fields.promoName"
                      source="name"
                    />
                    <DateField
                      label="resources.promos.fields.validFrom"
                      source="valid_from"
                    />
                    <DateField
                      label="resources.promos.fields.validTo"
                      source="valid_to"
                    />

                    <ReferenceArrayField
                      label="resources.promos.fields.industry"
                      source="industries_id"
                      reference="industries"
                    >
                      <SingleFieldList>
                        <ChipField source="name" />
                      </SingleFieldList>
                    </ReferenceArrayField>

                    <ReferenceField
                      label="resources.promos.fields.marketingPartner"
                      source="marketing_partner_id"
                      reference="marketing_partners"
                      linkType={false}
                    >
                      <TextField source="name" />
                    </ReferenceField>

                    <BooleanField
                      label="resources.promos.fields.active"
                      source="active"
                    />
                  </ReferenceSelectGrid>
                </ReferenceArrayInputNestedFilter>
              </FormTab>
            )}

          <FormTab
            label="resources.stores.titleTab4"
            elStyle={formStyle.tabStyle}
          >

            <InputHeader
                header="resources.stores.inputs.marketingPartner.mrGreen.name"
                headerStyle={formStyle.headerContainer}
                style={formStyle.headerSectionStyle}
            />
            <div style={formStyle.clearFloatContainer} />
            <TextInput
                label="resources.stores.inputs.marketingPartner.mrGreen.marketingSourceId"
                source="extra.mrgreen.marketing_source_id"
                validate={validateMarketingPartnerID}
            />

            <InputHeader
              header="resources.stores.inputs.marketingPartner.william_hill.name"
              headerStyle={formStyle.headerContainer}
              style={formStyle.headerSectionStyle}
            />
            <div style={formStyle.clearFloatContainer} />
            <TextInput
              label="resources.stores.inputs.marketingPartner.william_hill.pid"
              source="extra.william_hill.pid"
            />


            <InputHeader
                header="resources.stores.inputs.marketingPartner.cashbacker.name"
                headerStyle={formStyle.headerContainer}
                style={formStyle.headerSectionStyle}
            />
            <div style={formStyle.clearFloatContainer} />
            <BooleanInput
                label="resources.stores.inputs.giftcard"
                source="extra.cashbacker.gift_card_enabled"
                defaultValue
                style={formStyle.inputStyle.booleanInput}
            />



            <InputHeader
                header="resources.stores.inputs.marketingPartner.storemarket.name"
                headerStyle={formStyle.headerContainer}
                style={formStyle.headerSectionStyle}
            />
            <div style={formStyle.clearFloatContainer} />
            <BooleanInput
                label="resources.stores.inputs.giftcard"
                source="extra.storemarket.gift_card_enabled"
                defaultValue
                style={formStyle.inputStyle.booleanInput}
            />

            <InputHeader
              header="resources.stores.inputs.marketingPartner.betfair.name"
              headerStyle={formStyle.headerContainer}
              style={formStyle.headerSectionStyle}
            />
            <div style={formStyle.clearFloatContainer} />
            <TextInput
              label="resources.stores.inputs.marketingPartner.betfair.pid"
              source="extra.betfair.pid"
            />

          </FormTab>
        </TabbedForm>
      </Create>
    );
  }
}

const mapStateToProps = state => {
  return {
    errors: state.form[`record-form`],
    configuration: state.configuration
  };
};

export default connect(mapStateToProps)(translate(StoreCreateForm));



// WEBPACK FOOTER //
// ./src/containers/CRM/Stores/StoreCreateForm.js